// angular
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ConfigService } from './config.service';

// addons
import { Observable } from 'rxjs';

@Injectable()
export class ApiService {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService
  ) {}

  get apiUrl() {
    return environment.apiUrl;
  }

  get api2Url() {
    return '/api2';
  }

  mapParams(obj: any): HttpParams {
    let params: HttpParams = new HttpParams();

    Object.keys(obj).forEach(key => {
      const paramValue = obj[key];

      if (
        paramValue === null
        || paramValue === undefined
        || !String(paramValue).length
      ) {
        return;
      }

      params = params.append(key, obj[key]);
    });

    return params;
  }

  get(path: string, params?: HttpParams): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}${path}`, { params });
  }

  get2(path: string, params?: HttpParams): Observable<any> {
    return this.httpClient.get(`${this.api2Url}${path}`, { params });
  }

  post(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}${path}`, body);
  }

  post2(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.post(`${this.api2Url}${path}`, body);
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.put(`${this.apiUrl}${path}`, body);
  }

  put2(path: string, body: Object = {}): Observable<any> {
    return this.httpClient.put(`${this.api2Url}${path}`, body);
  }

  delete(path: string): Observable<any> {
    return this.httpClient.delete(`${this.apiUrl}${path}`);
  }

  delete2(path: string): Observable<any> {
    return this.httpClient.delete(`${this.api2Url}${path}`);
  }
}
